import React from "react";
import NotifBell from "./NotifBell";

export default function StaffHeader({user,lang,switchLang,onLogout,dispatch,notifications,t,appName}){
  const isRTL=lang==="ar";
  return(
    <div className="staff-hdr">
      <div className="staff-hdr-logo">{appName||"TR OS"}</div>
      <div style={{display:"flex",gap:6,alignItems:"center",marginInlineStart:"auto"}}>
        <div style={{display:"flex",gap:4}}>
          <button className={`lang-btn ${lang==="en"?"active":""}`} onClick={()=>switchLang("en")} style={{padding:"4px 8px",fontSize:11}}>EN</button>
          <button className={`lang-btn ${lang==="ar"?"active":""}`} onClick={()=>switchLang("ar")} style={{padding:"4px 8px",fontSize:11}}>ع</button>
        </div>
        <NotifBell notifications={notifications} userId={user.id} dispatch={dispatch} lang={lang}/>
        <button className="btn btn-g btn-sm" onClick={onLogout}>{t.signOut}</button>
      </div>
    </div>
  );
}
